import { Button, CodeEntry, Heading, Modal, Text } from '@afterpaytouch/core'
import { Trans, useTranslation } from 'next-i18next'
import React, { FunctionComponent, useContext } from 'react'
import { useFormatMobile, useCodeEntry } from '../../../../hooks'
import { useConsumerSelector } from '../../../../state'
import { useChangeEmailCheckMobileMutation, useChangeEmailReverifyMobileMutation } from '../../../../state/account/changeEmail'
import { EditEmailAddressModalContext, EditEmailAddressSteps } from '../../EditEmailAddressModal'

const I18N_NAMESPACE = ['common', 'account']

export const Init: FunctionComponent = () => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { phoneNumber } = useConsumerSelector()
  const { codeEntryRef, codeEntryKey, resetCodeEntry } = useCodeEntry()
  const { token, setStep } = useContext(EditEmailAddressModalContext)

  const [reverifyMobile, { isLoading: isReverifyMobileLoading }] = useChangeEmailReverifyMobileMutation()

  const rerequestMobileCode = (): void => {
    reverifyMobile({ body: { token } })
  }

  const [checkMobile, { isError: isCheckMobileError, isLoading: isCheckMobileLoading }] = useChangeEmailCheckMobileMutation()

  const onCodeEntryComplete = async (code: string): Promise<void> => {
    try {
      await checkMobile({
        body: {
          code,
          token,
        },
      }).unwrap()
      setStep(EditEmailAddressSteps.Edit)
    } catch (err) {
      resetCodeEntry()
    }
  }

  const isCodeEntryDisabled = isReverifyMobileLoading || isCheckMobileLoading

  const testNameSpace = 'edit-email-address-modal-init'

  return (
    <>
      <Modal.Header divider>
        <div className='text-center'>
          <Heading testNameSpace={testNameSpace} size='L'>
            {t('account:edit:email:init:header:heading')}
          </Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div>
          <div className='mt-2'>
            <Text>{t('account:edit:email:init:content:message', { mobile: useFormatMobile(phoneNumber) })}</Text>
          </div>
          <div className='mt-4'>
            <CodeEntry
              codeEntryLength={6}
              onComplete={onCodeEntryComplete}
              disabled={isCodeEntryDisabled}
              error={isCheckMobileError}
              errorText={t('account:edit:email:init:content:code-entry:error')}
              testNameSpace={testNameSpace}
              ref={codeEntryRef}
              key={codeEntryKey}
            />
          </div>
          <div className='mt-6'>
            <Text size='S'>
              <Trans
                i18nKey='account:edit:email:init:content:resend'
                components={{
                  resendButton: <Button.Link size='Regular' onClick={rerequestMobileCode} />,
                }}
              />
            </Text>
          </div>
        </div>
      </Modal.Content>
    </>
  )
}
